import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import moment from 'moment';

export default function useDailyStandaloneCartsSummary(date = new Date()) {
      const { activeShopId } = useSelector((state) => state.shops);
      const [daily, setDaily] = useState({});

      useEffect(() => {
            if (!activeShopId) {
                  setDaily({});
                  return;
            }

            const startTime = moment(date).subtract(30, 'days').startOf('day').toDate();
            const endTime = moment(date).endOf('day').toDate();

            const standaloneCartsRef = firebase
                  .firestore()
                  .collection('shops')
                  .doc(activeShopId)
                  .collection('carts')
                  .where('createdAt', '>=', startTime)
                  .where('createdAt', '<=', endTime)
                  .where('cartType', '==', 'standaloneCart');

            const fetchCarts = async () => {
                  try {
                        const snapshot = await standaloneCartsRef.get();

                        const totalsByDay = {};

                        snapshot.forEach((doc) => {
                              const data = doc.data();
                              const createdAt = data.createdAt?.toDate ? data.createdAt.toDate() : null;
                              if (!createdAt) return;

                              const day = moment(createdAt).format('YYYY-MM-DD');
                              const orderAmount = typeof data.totalOrderAmount === 'number' ? data.totalOrderAmount : 0;
                              totalsByDay[day] = (totalsByDay[day] || 0) + orderAmount;
                        });

                        // Include all days in range with zero count if no data
                        const dailyData = {};
                        for (let m = moment(startTime); m.isSameOrBefore(endTime, 'day'); m.add(1, 'day')) {
                              const dayStr = m.format('YYYY-MM-DD');
                              dailyData[dayStr] = { salesTotal: totalsByDay[dayStr] || 0 };
                        }

                        setDaily(dailyData);
                  } catch (error) {
                        console.error('Error fetching standalone carts:', error);
                        setDaily({});
                  }
            };

            fetchCarts();
      }, [activeShopId, date]);

      return { daily };
}
